import { useEffect } from "react";
import { Hero } from "../components/Hero";
import { About } from "../components/About";
import { Services } from "../components/Services";
import { Contact } from "../components/Contact";
import { Marquee, StatBand } from "../components/Marquee";
import { Reveal } from "../components/Reveal";
import { Link, useLocation } from "react-router-dom";
import { IMAGES } from "../lib/site";

export const HomePage = () => {
  const { hash, pathname } = useLocation();

  // Scroll to anchor when navigating with hash
  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) {
        setTimeout(
          () => el.scrollIntoView({ behavior: "smooth", block: "start" }),
          80
        );
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [hash, pathname]);

  return (
    <main data-testid="home-page">
      <Hero />
      <StatBand />
      <About />
      <Marquee />
      <Services />

      {/* Gallery teaser */}
      <section
        data-testid="gallery-teaser"
        className="bg-[#F9F9F6] py-24 md:py-32 px-6 md:px-12 lg:px-24"
      >
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 items-end mb-12">
          <Reveal className="md:col-span-7">
            <p className="text-[11px] uppercase tracking-[0.32em] text-[#965C3B]">
              Selected Work
            </p>
            <h2 className="mt-6 font-display text-4xl sm:text-5xl md:text-6xl tracking-tighter leading-[0.95] text-[#1A2B22]">
              Moments from the
              <br />
              <em className="italic font-normal text-[#965C3B]">
                show ring & beyond.
              </em>
            </h2>
          </Reveal>
          <Reveal delay={150} className="md:col-span-5 md:text-right">
            <Link
              to="/gallery"
              data-testid="home-gallery-cta"
              className="inline-flex items-center gap-3 px-6 py-3 border border-[#1A2B22] text-[#1A2B22] text-xs uppercase tracking-[0.24em] hover:bg-[#1A2B22] hover:text-[#F9F9F6] transition-colors"
            >
              View full gallery
              <span aria-hidden>→</span>
            </Link>
          </Reveal>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-12 gap-3 md:gap-4">
          {IMAGES.gallery.slice(0, 4).map((g, i) => (
            <Reveal
              key={i}
              delay={i * 80}
              className={`overflow-hidden ${
                i === 0
                  ? "col-span-2 md:col-span-7 row-span-2"
                  : i === 1
                  ? "col-span-2 md:col-span-5"
                  : i === 2
                  ? "col-span-1 md:col-span-3"
                  : "col-span-1 md:col-span-2"
              }`}
            >
              <img
                src={g.src}
                alt={g.alt}
                className="w-full h-full object-cover aspect-[4/5] md:aspect-auto md:h-full transition-transform duration-[1.4s] hover:scale-[1.05]"
                loading="lazy"
              />
            </Reveal>
          ))}
        </div>
      </section>

      <Contact />
    </main>
  );
};

export default HomePage;
